import { connect } from 'react-redux';
import { compose } from 'redux';

import EditSub from './EditSub';
import { simoSubPage } from '../../decorators/subPage';
import {
  getIsAdmin,
  getSubmitStatus,
  getAllSimoInitialsSubs,
  getAllSimoInitialsSubsStatus,
} from '../../reducers';
import {
  updateSimoSub,
  fetchAllSimoInitialsSubs,
} from '../../actions/simoSubs';
import withSimoSubCoverageChoices from 'decorators/withSimoSubCoverageChoices';

const mapStateToProps = (state) => ({
  saveStatus: getSubmitStatus(state, 'sub'),
  isAdmin: getIsAdmin(state),
  initialSubs: getAllSimoInitialsSubs(state),
  initialSubsLoading: getAllSimoInitialsSubsStatus(state) === 'PENDING',
  carrierPrefix: 'simo',
  isSimo: true,
});

const mapDispatchToProps = {
  updateSub: updateSimoSub,
  fetchAllInitialsSubs: fetchAllSimoInitialsSubs,
};

export default compose(
  simoSubPage,
  withSimoSubCoverageChoices,
  connect(mapStateToProps, mapDispatchToProps),
)(EditSub);
